import styled, { css } from 'styled-components';
import * as Cover from '@app/src/assets/img/cover.jpg';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { Assesors, Security } from '@app/src/common/footer';

interface Props {
  color?: string;
  isChangeOrientation?: boolean;
}

export const Wrapper = styled.div`
  position: relative;
  background: ${Cover && `url(${Cover})`};
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 486px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    background-size: cover;
  }
`;

export const Head = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 28px 34px 28px 16px;
  img {
    margin-top: 7px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding-left: 34px;
    background-color: white;
  }
`;

export const Foot = styled.div`
  width: 100%;
  padding: 0 40px 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  display: none;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
  }
`;

export const AssesorsWrapper = styled(Assesors)`
  h3 {
    font-size: 18px;
    line-height: 20px;
  }
  a {
    color: #333;
  }
`;

export const SecurityWrapper = styled(Security)`
  text-align: left;
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
`;

export const Information = styled.h1`
  font-family: ${FONTS.ARISTOTELICA};
  font-size: 24px;
  font-weight: 400;
  max-width: 287px;
  margin: 5% auto;
  line-height: 30px;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 60px;
    max-width: 819px;
    line-height: 66px;
    padding: 0;
    margin: 0 auto;
    color: white;

    h1 {
      font-size: 60px;
    }
  }
`;

export const Logos = styled.div`
  width: 100%;
  margin: 0 auto 30px;
  text-align: center;
  img {
    width: 93px;
    &:last-child {
      margin-left: 10px;
    }
  }
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 2% 0;
    img {
      width: 208px;
      &:last-child {
        margin-left: 20px;
      }
    }
  }
`;

export const WrapperIcons = styled.span`
  width: 100px;
  height: 100px;
  display: flex;
  cursor: pointer;
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  ${(props: Props) => props.color && css`
    border: 2px solid ${props.color};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.24);
    transition: .3s ease;

    svg {
      fill: ${props.color};
    }

    &:hover {
      background-color: ${props.color};
      transition: .3s ease;

      span {
        color: white;
      }

      svg {
        fill: white;
      }
    }
  `}

  &:nth-child(1) {
    position: absolute;
    top: 0;
  }

  &:nth-child(2) {
    position: absolute;
    left: 0;
    top: 65px;
  }

  &:nth-child(3) {
    position: absolute;
    right: 0;
    top: 65px;
  }

  &:nth-child(4) {
    position: absolute;
    bottom: 0;
    left: 45px;
  }

  &:nth-child(5) {
    position: absolute;
    bottom: 0;
    right: 45px;
  }

  a {
    color: ${COLORS.BLACK};
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }

  span {
    display: block;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 150px;
    height: 150px;

    &:nth-child(n) {
      position: static;
    }

    svg {
      width: 50px;
      height: 50px;
    }
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  max-width: 315px;
  margin: 0 10px 20%;
  font-size: 13px;
  box-sizing: border-box;
  position: relative;
  min-height: 280px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 819px;
    margin: 4% auto 2%;
    min-height: auto;

    svg {
      width: 50px;
      height: 50px;
    }
  }
`;

export const Shadow = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgb(251,251,251,.9);

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    background: linear-gradient(180deg, rgba(68, 68, 68, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  ${(props: Props) => props.isChangeOrientation && css`
    ${Information} {
      margin: 0 auto;
    }

    ${Logos} {
      margin: 0 auto;
      width: auto;
    }
  `}

  @media(min-width: 768px) {
    ${Logos} {
      width: 100%;
    }
  }
`;

export const Bold = styled.span`
  font-size: 24px;
  font-weight: 600;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 60px;
  }
`;

export const Title = styled.span`
  font-size: 12px;
  color: ${COLORS.BLACK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Price = styled.span`
  font-size: 10px;
  color: ${COLORS.GRAY_TEXT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    background-color: white;
  }
`;
